import { render, staticRenderFns } from "./BlogContentSection.vue?vue&type=template&id=7c361c4c&scoped=true&"
import script from "./BlogContentSection.vue?vue&type=script&lang=js&"
export * from "./BlogContentSection.vue?vue&type=script&lang=js&"
import style0 from "./BlogContentSection.vue?vue&type=style&index=0&id=7c361c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c361c4c",
  null
  
)

export default component.exports